import type { BoardSummary } from "@mn/shared";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router";
import { Shell } from "@/components/Shell";
import { Button } from "@/components/ui";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";

type Item = BoardSummary & { deletedAt: string };

export default function Trash() {
  const t = useT();
  const [items, setItems] = useState<Item[] | null>(null);
  const load = useCallback(async () => setItems(await api<Item[]>("/api/trash")), []);
  useEffect(() => {
    void load();
  }, [load]);
  async function restore(id: string) {
    await api(`/api/boards/${id}/restore`, { method: "POST" });
    await load();
  }
  return (
    <Shell>
      <div className="mx-auto max-w-3xl px-6 py-8">
        <h1 className="display mb-6 text-4xl">.{t.trash}</h1>
        <ul className="divide-y divide-border">
          {items?.length === 0 ? <li className="py-2 text-sm text-dim">—</li> : null}
          {items?.map((b) => (
            <li key={b.id} className="flex items-center gap-3 py-3 text-sm">
              <span className="flex-1 font-semibold">{b.title}</span>
              <span className="text-dim">{new Date(b.deletedAt).toLocaleString("es-MX")}</span>
              <Button variant="ghost" onClick={() => restore(b.id)}>
                {t.restore}
              </Button>
              {b.parentId ? (
                <Link to={`/b/${b.parentId}`} className="text-dim hover:text-text">
                  ↑
                </Link>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </Shell>
  );
}
